export const LogLevel = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40,
    supress: 50,
};
export const buildSimpleLogger = (logger) => {
    if (typeof logger === 'undefined') {
        return new SimpleLogger(console, LogLevel.supress);
    }
    else if (typeof logger === 'number') {
        return new SimpleLogger(console, logger);
    }
    else {
        return logger;
    }
};
export class SimpleLogger {
    constructor(logger, level) {
        this.logger = logger;
        this.level = level;
    }
    debug(message, ...data) {
        if (this.level <= LogLevel.debug) {
            this.logger.debug(message, ...data);
        }
    }
    info(message, ...data) {
        if (this.level <= LogLevel.info) {
            this.logger.info(message, ...data);
        }
    }
    warn(message, ...data) {
        if (this.level <= LogLevel.warn) {
            this.logger.warn(message, ...data);
        }
    }
    error(message, ...data) {
        if (this.level <= LogLevel.error) {
            this.logger.error(message, ...data);
        }
    }
}
